/* eslint-disable react/react-in-jsx-scope */
import { Dialog, makeStyles } from "@material-ui/core";
import { Assignment } from "@material-ui/icons";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardFooter from "components/Card/CardFooter";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CustomInput from "components/CustomInput/CustomInput";
import GridItem from "components/Grid/GridItem";
import { bookingApi } from "functions/apis";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import ReactTable from "react-table";
import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

export default function NotificationDialog(props) {
  const classes = useStyles();
  const [pages, setPages] = useState(0);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 5
  });
  const [filter, setFilter] = useState({
    searchString: ""
  });
  const [loading, setLoading] = useState(false);

  const { onSelect, setOpenModal, openModal } = props;

  const notificationDialogSignal = useRef(new AbortController());

  useEffect(() => {
    return () => notificationDialogSignal.current.abort();
  }, []);

  useEffect(() => {
    setLoading(true);
    bookingApi
      .get("AppsNotifications", {
        params: {
          filter,
          pagination
        },
        signal: notificationDialogSignal.current.signal
      })
      .then(resp => {
        setData(
          resp.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  <a
                    onClick={() => {
                      onSelect && onSelect(record);
                    }}
                  >
                    <Button color="info" className="like">
                      Select
                    </Button>
                  </a>
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(resp.totalRecords / pagination.pageSize));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filter, pagination]);

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  return (
    <Dialog
      open={openModal}
      onClose={(_event, reason) => {
        if (reason === "backdropClick") {
          setOpenModal(false);
        }
      }}
      fullWidth
      maxWidth="md"
    >
      <Card xs={10} md={6}>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>NOTIFICATION</h4>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} md={3}>
            <CustomInput
              labelText="Search"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: handleSearchStringChanged,
                value: filter.searchString === null ? "" : filter.searchString
              }}
            />
          </GridItem>
          <ReactTable
            manual
            pages={pages}
            page={pagination.pageIndex - 1}
            pageSize={pagination.pageSize}
            onPageChange={page =>
              setPagination({
                pageIndex: page + 1,
                pageSize: pagination.pageSize
              })
            }
            onPageSizeChange={(pageSize, page) => {
              setPagination({ pageSize: pageSize, pageIndex: page + 1 });
            }}
            loading={loading}
            data={data}
            filterable={false}
            columns={[
              {
                Header: "Name",
                accessor: "name"
              },
              {
                Header: "Title",
                accessor: "title"
              },
              {
                Header: "Description",
                accessor: "description"
              },
              {
                Header: "Actions",
                accessor: "actions",
                sortable: false,
                filterable: false
              }
            ]}
            defaultPageSize={10}
            showPaginationTop
            showPaginationBottom={false}
            className="-striped -highlight"
          />
        </CardBody>
      </Card>
      <CardFooter>
        <Button
          onClick={() => {
            setOpenModal(false);
          }}
          type="submit"
          color="danger"
          size="sm"
          block
        >
          Close
        </Button>
      </CardFooter>
    </Dialog>
  );
}

NotificationDialog.propTypes = {
  onSelect: PropTypes.func,
  openModal: PropTypes.bool,
  setOpenModal: PropTypes.func
};
